import { useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Button } from '@/components/Button';
import ClientMobileNav from '@/components/ClientNav/ClientMobileNav';

const HeaderTitle = {
  '/task': '업무관리',
  '/chat': '문의/답변',
  '/notices': '공지사항',
  '/account': '마이페이지',
};

const MobileHeader = () => {
  const [showVenueSelection, setShowVenueSelection] = useState(false);
  const { pathname } = useLocation();
  const rootPath = '/' + pathname.split('/')[1];

  return (
    <header className="fixed top-0 left-0 right-0 flex items-center justify-between h-16 px-4 py-2 bg-white w-full border-b border-gray-200 z-9999">
      <h1 className="text-lg font-bold">{HeaderTitle[rootPath]}</h1>
      {rootPath === '/task' && (
        <Button
          size="xs"
          variant="ghost"
          onClick={() => setShowVenueSelection(true)}
        >
          지점선택
        </Button>
      )}
      {showVenueSelection && (
        <ClientMobileNav onClose={() => setShowVenueSelection(false)} />
      )}
    </header>
  );
};

export default MobileHeader;
